/* ---------------------------------------------------------------------------
   BC Nordic — megameny som åpnes med klikk (23.09.2026, bestilt av Jonas)

   Før: panelene åpnet rent i CSS på :hover / :focus-within (bc-header.css).
   Nå: klikk på et toppunkt med panel åpner det, og det står åpent til
   brukeren lukker det. Uten JavaScript virker den gamle hover-menyen som før
   — klassen .is-click-mode settes først her, og all klikk-CSS henger på den.

   Oppførsel:
   • Klikk på toppunkt med panel: åpner/lukker panelet. Lenken beholder sin
     href (SEO og «åpne i ny fane»): Cmd/Ctrl/Shift/midtklikk navigerer som
     vanlig. Selve siden nås via lenken nederst/øverst i hvert panel.
   • Når ett panel er åpent, bytter musepeker over et annet toppunkt panel
     direkte (som menylinjen på Mac/Windows). Peker over et toppunkt uten
     panel (Eir AI, Kampanjer …) lukker det åpne panelet.
   • Lukkes ved: nytt klikk på samme punkt, klikk utenfor menyen, Esc
     (fokus tilbake til toppunktet), klikk på en lenke i panelet, rulling
     mer enn 80 px siden panelet ble åpnet, fokus som forlater menyen, og
     når vinduet blir smalere enn desktop-menyen (1200 px).
   • Tilgjengelighet: aria-haspopup, aria-expanded og aria-controls settes
     på toppunktene; mellomrom åpner/lukker i tillegg til Enter. Lukkede
     paneler er visibility:hidden i klikk-modus, så Tab ikke havner i
     usynlige lenker.
--------------------------------------------------------------------------- */
(function () {
  var nav = document.querySelector('[data-bc-mega]');
  if (!nav || nav.dataset.bcMegaClick) return;
  nav.dataset.bcMegaClick = '1';
  nav.classList.add('is-click-mode');

  var items = Array.prototype.slice.call(nav.querySelectorAll('.bc-mega-nav__item'));
  var openItem = null;
  var openScrollY = 0;

  function panelOf(item) { return item.querySelector(':scope > [data-mega="panel"]'); }
  function linkOf(item) { return item.querySelector(':scope > .bc-mega-nav__link'); }

  items.forEach(function (item, i) {
    var panel = panelOf(item);
    var link = linkOf(item);
    if (!panel || !link) return;
    if (!panel.id) panel.id = 'bc-mega-panel-' + (i + 1);
    link.setAttribute('aria-haspopup', 'true');
    link.setAttribute('aria-expanded', 'false');
    link.setAttribute('aria-controls', panel.id);
  });

  function close(returnFocus) {
    if (!openItem) return;
    var link = linkOf(openItem);
    openItem.classList.remove('is-open');
    if (link) {
      link.setAttribute('aria-expanded', 'false');
      if (returnFocus) link.focus();
    }
    openItem = null;
  }

  function open(item) {
    if (openItem === item) return;
    if (openItem) close(false);
    var link = linkOf(item);
    item.classList.add('is-open');
    if (link) link.setAttribute('aria-expanded', 'true');
    openItem = item;
    openScrollY = window.scrollY;
  }

  items.forEach(function (item) {
    var panel = panelOf(item);
    var link = linkOf(item);
    if (!link) return;

    if (panel) {
      link.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        e.preventDefault();
        if (openItem === item) close(false); else open(item);
      });
      link.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          if (openItem === item) close(false); else open(item);
        }
      });
      panel.addEventListener('click', function (e) {
        if (e.target.closest('a[href]')) close(false);
      });
    }

    // Kun ekte mus: på berøringsskjerm sender nettleseren en etterlignet
    // mouseenter før klikket, som ellers ville åpnet og straks lukket panelet.
    item.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (!openItem || openItem === item) return;
      if (panel) open(item); else close(false);
    });
  });

  document.addEventListener('click', function (e) {
    if (openItem && !nav.contains(e.target)) close(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openItem) close(true);
  });

  nav.addEventListener('focusout', function (e) {
    if (openItem && e.relatedTarget && !nav.contains(e.relatedTarget)) close(false);
  });

  window.addEventListener('scroll', function () {
    if (openItem && Math.abs(window.scrollY - openScrollY) > 80) close(false);
  }, { passive: true });

  var desktop = window.matchMedia('(min-width: 1200px)');
  var onChange = function () { if (!desktop.matches) close(false); };
  if (desktop.addEventListener) desktop.addEventListener('change', onChange);
  else if (desktop.addListener) desktop.addListener(onChange);
})();
